import { MarketplaceIntelligenceBaseApiClient } from '../marketplace-intelligence/client';
import type {
  CreateSchedulePayload,
  Schedule
} from '@interfaces/Schedule.interface';

export class ApiSchedules extends MarketplaceIntelligenceBaseApiClient {
  list(): Promise<Schedule[]> {
    return this.get<Schedule[]>('/api/v1/schedules');
  }

  create(payload: CreateSchedulePayload): Promise<Schedule> {
    return this.post<Schedule>('/api/v1/schedules', payload);
  }

  remove(scheduleId: string): Promise<void> {
    return this.delete(`/api/v1/schedules/${encodeURIComponent(scheduleId)}`);
  }

  /** Alias for remove */
  destroy(scheduleId: string): Promise<void> {
    return this.remove(scheduleId);
  }

  pause(scheduleId: string): Promise<Schedule> {
    return this.post<Schedule>(
      `/api/v1/schedules/${encodeURIComponent(scheduleId)}/pause`
    );
  }

  resume(scheduleId: string): Promise<Schedule> {
    return this.post<Schedule>(
      `/api/v1/schedules/${encodeURIComponent(scheduleId)}/resume`
    );
  }
}

export { schedulesQueryKeys } from './query-keys';
export * from './use-schedules-queries';
export * from './use-schedules-mutations';
export { ApiSchedules as SchedulesApi };
